import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { UnloadingDetails, UnloadingDetailsEnum } from "types/UnloadingDetails";

const UnloadingDetailsSelect: React.FC<{
  selected?: UnloadingDetails | null | undefined;
  onSelect: (routing: UnloadingDetails | null) => void;
  hasError?: boolean;
  className?: string;
}> = ({ selected, onSelect, hasError, className }) => {
  const { t } = useTranslation(["common", "shipper"]);

  const routingOptions = [
    { value: UnloadingDetailsEnum.DROP, label: t("common:dropAndPick") },
    { value: UnloadingDetailsEnum.LIVE, label: t("common:liveUnload") },
    { value: null, label: t("shipper:n/a") },
  ];
  return (
    <div
      className={clsx(
        "flex space-x-1 p-1 rounded-lg w-full",
        className,
        hasError ? "bg-red-50 border border-red-300" : "bg-gray-100"
      )}
    >
      {routingOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onSelect(option.value)}
          className={clsx(
            "px-4 py-2 rounded-md text-sm font-medium transition-colors border flex-1",
            selected === option.value
              ? "border-blue-600 text-blue-600 bg-white shadow-sm"
              : "border-transparent text-gray-700 hover:text-gray-900 hover:bg-gray-200"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default UnloadingDetailsSelect;
